(function() {
  function normalizeCountryList(value) {
    if (!value) {
      return [];
    }

    return value
      .split(',')
      .map(function(code) {
        return code.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (error) {
      return null;
    }
  }

  function shouldResetPopups() {
    var resetValue = getQueryParam('geo_popup_reset');
    return resetValue === '1' || resetValue === 'true';
  }

  function getCurrentCountryCode(element) {
    var overrideCountry = getQueryParam('geo_popup_country');
    var bodyCountry = document.body ? document.body.getAttribute('data-current-country') : '';
    var popupCountry = element.getAttribute('data-current-country') || '';
    var shopifyCountry = window.Shopify && window.Shopify.country ? window.Shopify.country : '';

    return (overrideCountry || shopifyCountry || popupCountry || bodyCountry || '').toUpperCase();
  }

  function getHideUntil(storageKey) {
    try {
      return parseInt(window.localStorage.getItem(storageKey), 10) || 0;
    } catch (error) {
      return 0;
    }
  }

  function setHideUntil(storageKey, days) {
    if (!days || days < 1) {
      return;
    }

    try {
      window.localStorage.setItem(storageKey, String(Date.now() + (days * 24 * 60 * 60 * 1000)));
    } catch (error) {
      return;
    }
  }

  function clearHideUntil(storageKey) {
    try {
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      return;
    }
  }

  function closePopup() {
    if (window.jQuery && window.jQuery.fancybox) {
      window.jQuery.fancybox.close();
    }
  }

  function bindDismissActions(element, hideDays, storageKey) {
    var dismissors = element.querySelectorAll('[data-geo-distributor-close], [data-geo-distributor-link]');

    dismissors.forEach(function(node) {
      node.addEventListener('click', function(event) {
        var isDismissLink = node.hasAttribute('data-geo-distributor-close') && node.tagName === 'A';

        setHideUntil(storageKey, hideDays);

        if (isDismissLink) {
          event.preventDefault();
        }

        closePopup();
      });
    });
  }

  function openPopup(element) {
    if (!(window.jQuery && window.jQuery.fancybox)) {
      return;
    }

    window.jQuery.fancybox.open({
      src: '#' + element.id,
      type: 'inline',
      opts: {
        baseClass: 'popup-modal geo-distributor-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        }
      }
    });
  }

  function matchesCountry(element, currentCountry) {
    var targets = normalizeCountryList(element.getAttribute('data-country-codes'));

    if (!targets.length || !currentCountry) {
      return false;
    }

    return targets.indexOf(currentCountry) !== -1;
  }

  function shouldShowPopup(element, currentCountry) {
    var storageKey = element.getAttribute('data-storage-key');
    var hideUntil = getHideUntil(storageKey);

    if (!matchesCountry(element, currentCountry)) {
      return false;
    }

    if (hideUntil && Date.now() < hideUntil) {
      return false;
    }

    return true;
  }

  function getMatchingPopup(container, currentCountry) {
    var options = container.querySelectorAll('[data-geo-distributor-option]');

    for (var index = 0; index < options.length; index += 1) {
      if (shouldShowPopup(options[index], currentCountry)) {
        return options[index];
      }
    }

    return null;
  }

  function resetPopups(container) {
    var options = container.querySelectorAll('[data-geo-distributor-option]');

    options.forEach(function(option) {
      clearHideUntil(option.getAttribute('data-storage-key'));
    });
  }

  function initPopup(container) {
    if (!container) {
      return;
    }

    if (shouldResetPopups()) {
      resetPopups(container);
    }

    var currentCountry = getCurrentCountryCode(container);
    var element = getMatchingPopup(container, currentCountry);

    if (!element || !element.id) {
      return;
    }

    var delaySeconds = parseInt(container.getAttribute('data-popup-delay'), 10) || 0;
    var hideDays = parseInt(container.getAttribute('data-hide-days'), 10) || 0;
    var storageKey = element.getAttribute('data-storage-key');

    bindDismissActions(element, hideDays, storageKey);

    window.setTimeout(function() {
      openPopup(element);
    }, delaySeconds * 1000);
  }

  function boot() {
    var element = document.querySelector('[data-geo-distributor-popup]');

    if (!element) {
      return;
    }

    initPopup(element);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
